/** Suggested starter prompts for the Conversation anchor empty state.
 *  Lexicon is locked to the Memso brand: weave / capture / recall /
 *  synthesize. The word "brain" must NOT appear in any user-facing
 *  surface. */
export interface StarterPrompt {
  /** Headline shown on the chip. */
  label: string;
  /** Sub-line shown under the chip - one-liner that previews what
   *  Memso will surface when the user picks it. */
  hint: string;
  /** What gets dropped into the composer when the user taps. */
  query: string;
}

export const STARTER_PROMPTS: StarterPrompt[] = [
  {
    label: "What did I learn last week?",
    hint: "Synthesize the threads you wove",
    query: "What did I learn last week?",
  },
  {
    label: "Surface yesterday's open threads",
    hint: "Recall what's still in flight",
    query: "Surface yesterday's open threads.",
  },
  {
    label: "What should I focus on today?",
    hint: "Weave deadlines, follow-ups, and momentum",
    query: "What should I focus on today?",
  },
  {
    label: "Who came up most this month?",
    hint: "Recall the people in your orbit",
    query: "Who came up most in my captures this month?",
  },
];
